export const i18nKeyPrefix = 'DASHBOARD-AVAILABILITY'
